export const personasCookieKey = 'sc-persona';
